import { 
    CreateAgeBracketDto,
    DeleteAgeBracketDto,
    EditAgeBracketDto,
    GetAgeBracketDto,
    MessageResponseDto,
    UtilAgeBracketControllerGet200Response,
    UtilityAgeBracketApiFp, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseUtilAgeBracketModel = UtilAgeBracketControllerGet200Response;
export type GetUtilAgeBracketModel = GetAgeBracketDto;
export type MutateResponseUtilAgeBracketModel = MessageResponseDto;
export type CreateUtilAgeBracketModel = CreateAgeBracketDto;
export type UpdateUtilAgeBracketModel = EditAgeBracketDto;
export type DeleteUtilAgeBracketModel = DeleteAgeBracketDto;

export const apiUtilAgeBracketFp = UtilityAgeBracketApiFp(apiConfig);
export const getUtilAgeBracketController = apiUtilAgeBracketFp.utilAgeBracketControllerGet;
export const createUtilAgeBracketController = apiUtilAgeBracketFp.utilAgeBracketControllerCreate;
export const updateUtilAgeBracketController = apiUtilAgeBracketFp.utilAgeBracketControllerEdit;
export const deleteUtilAgeBracketController = apiUtilAgeBracketFp.utilAgeBracketControllerDelete;

export const QueryKeyUtilAgeBracket = QueryKey.UtilAgeBracket;